'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { facebookContentAtom, TFacebookContent } from './FacebookContentState'
import { FacebookScreen } from './FacebookScreen/FacebookScreen'

export const FacebookLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TFacebookContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[facebookContentAtom, content],
	])

	return <FacebookScreen previewMode={false} demoMode={false} />
}
